module.exports={Earlier:"이전",New:"신규",NoAnnouncements:"공지사항 없음"};